module.exports = __webpack_public_path__ + "static/media/teamsLanding.3bd4f928.png";